import { useEffect } from 'react';

const SEO = ({ title, description, path, image }) => {
  useEffect(() => {
    const pageTitle = title ? title + ' | MoveToEurope' : 'MoveToEurope - Your Complete Guide to Relocating to Europe';
    document.title = pageTitle;

    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector('meta[name="' + name + '"]') || document.querySelector('meta[property="' + name + '"]');
      if (!el) {
        el = document.createElement('meta');
        if (name.startsWith('og:') || name.startsWith('twitter:')) {
          el.setAttribute('property', name);
        } else {
          el.setAttribute('name', name);
        }
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const pageDesc = description || 'Everything you need to know about moving to Europe. Guides for regions across Italy, Spain, and Portugal — cost of living, schools, visa advice, community forum.';
    const pageImage = image || 'https://images.unsplash.com/photo-1726009955672-eaf577c89972?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200';
    const pageUrl = 'https://movetoeurope.net' + (path || '');

    setMeta('description', pageDesc);
    setMeta('og:title', pageTitle);
    setMeta('og:description', pageDesc);
    setMeta('og:image', pageImage);
    setMeta('og:url', pageUrl);
    setMeta('og:type', 'website');
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', pageTitle);
    setMeta('twitter:description', pageDesc);
    setMeta('twitter:image', pageImage);
  }, [title, description, path, image]);

  return null;
};

export default SEO;
